'use strict';
import { tns } from "tiny-slider/src/tiny-slider"

class LatestVideos {

	constructor($target) {

		//Private properties
		$target;

		

		let name = "HELLO";

		function init(){
			initSLider()
			playVideoBtn()
			pausedVideoWhenClick()
		}

		function onPausedVideoWhenClick(){
			
			$('.video__src').each( (i , e )=> {

				var src = $(e).find('iframe')[0].src;

				if( src.includes('autoplay=1')){
					src = src.replace('?autoplay=1', '')
					$(e).find('iframe')[0].src = src
				}

			}); 
		}
		
		function pausedVideoWhenClick(){
			$target.find('.tns-nav').on('click', 'button', onPausedVideoWhenClick)
		}

		
		function playVideoBtn(){
			var videoBtn = $target.find('.block_latest_videos__video-container');
			videoBtn.on('click', onClickEvent)
			
		}


		function onClickEvent(){

			//play video form youtube
			$(this).find('.video__src > iframe')[0].src += "?autoplay=1"

			//show video iframe
			$(this).find('.video__src').show()	

			//hide thumbnail
			$(this).find('.video__thumbnail__img').css('visibility', 'hidden')
			$(this).find('.block_latest_videos__play-button_img').hide()
			
		}

		
		function initSLider(){
			var slider = tns({
				container: $target.find('.block_latest_videos__videos')[0],
				items: 1,
				slideBy: 'page',
				autoplay: false,
				controls:false,
				nav: true,
				navPosition: "bottom",
				loop: false,
				edgePadding: 20,
				gutter: 20,
				responsive: {
					768: {
					  items: 2,
					},
					1200: {
						items: 3,
					  }
				}
			  });
		}

		init()
		return {

			//Public properties
			name:name,

			publicBlockHero:function(string){


			}

		}

	}

}

export default LatestVideos;